import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IUserJobsReportData } from "../../interfaces/analytics";

const useGetUserJobsReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IUserJobsReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/user-jobs-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['user-jobs-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetUserJobsReport;